import { put, takeLatest, takeEvery, call, select } from "redux-saga/effects";
import {
  PAYMENT_LIST_ACTION,
  PAYMENT_LIST_LOADING,
  PAYMENT_LIST_SUCCESS,
  PAYMENT_LIST_ERROR,
  GET_PAYMENT_ACTION,
  GET_PAYMENT_LOADING,
  GET_PAYMENT_SUCCESS,
  GET_PAYMENT_ERROR,
  MONTHS_TO_SETTLE_ACTION,
  MONTHS_TO_SETTLE_ERROR,
  MONTHS_TO_SETTLE_LOADING,
  MONTHS_TO_SETTLE_SUCCESS,
  BULK_MONTHS_TO_SETTLE_ACTION,
  BULK_MONTHS_TO_SETTLE_ERROR,
  BULK_MONTHS_TO_SETTLE_LOADING,
  BULK_MONTHS_TO_SETTLE_SUCCESS,
  SETTLE_PAYMENT_ACTION,
  SETTLE_PAYMENT_LOADING,
  SETTLE_PAYMENT_SUCCESS,
  SETTLE_PAYMENT_ERROR,
  SETTLE_SALARY_ACTION,
  SETTLE_SALARY_LOADING,
  SETTLE_SALARY_SUCCESS,
  SETTLE_SALARY_ERROR,
  BULK_SETTLE_SALARY_ACTION,
  BULK_SETTLE_SALARY_LOADING,
  BULK_SETTLE_SALARY_SUCCESS,
  BULK_SETTLE_SALARY_ERROR,
  COMPANY_LIST_ACTION,
  COMPANY_LIST_LOADING,
  COMPANY_LIST_SUCCESS,
  COMPANY_LIST_ERROR,
  GET_COMPANY_ACTION,
  GET_COMPANY_LOADING,
  GET_COMPANY_SUCCESS,
  GET_COMPANY_ERROR,
  EMPLOYEE_LIST_ACTION,
  EMPLOYEE_LIST_LOADING,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_LIST_ERROR,
  GET_EMPLOYEE_ACTION,
  GET_EMPLOYEE_LOADING,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_ERROR,
  OVERVIEW_ACTION,
  OVERVIEW_LOADING,
  OVERVIEW_SUCCESS,
  OVERVIEW_ERROR,
  INVITE_COMPANY_ACTION,
  INVITE_COMPANY_LOADING,
  INVITE_COMPANY_SUCCESS,
  INVITE_COMPANY_ERROR,
  UPDATE_COMPANY_ACTION,
  UPDATE_COMPANY_LOADING,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_ERROR,
  EXCHANGE_LIST_ACTION,
  EXCHANGE_LIST_LOADING,
  EXCHANGE_LIST_SUCCESS,
  EXCHANGE_LIST_ERROR,
  GET_EXCHANGE_ACTION,
  GET_EXCHANGE_LOADING,
  GET_EXCHANGE_SUCCESS,
  GET_EXCHANGE_ERROR,
  CREATE_EXCHANGE_ACTION,
  CREATE_EXCHANGE_LOADING,
  CREATE_EXCHANGE_SUCCESS,
  CREATE_EXCHANGE_ERROR,
  UPDATE_EXCHANGE_ACTION,
  UPDATE_EXCHANGE_LOADING,
  UPDATE_EXCHANGE_SUCCESS,
  UPDATE_EXCHANGE_ERROR,
  DELETE_EXCHANGE_ACTION,
  DELETE_EXCHANGE_LOADING,
  DELETE_EXCHANGE_SUCCESS,
  DELETE_EXCHANGE_ERROR,
  BACKOFFICE_DEDUCTION_LIST_ACTION,
  BACKOFFICE_DEDUCTION_LIST_LOADING,
  BACKOFFICE_DEDUCTION_LIST_SUCCESS,
  BACKOFFICE_DEDUCTION_LIST_ERROR,
  GET_DEDUCTION_ACTION,
  GET_DEDUCTION_LOADING,
  GET_DEDUCTION_SUCCESS,
  GET_DEDUCTION_ERROR,
  CREATE_DEDUCTION_ACTION,
  CREATE_DEDUCTION_LOADING,
  CREATE_DEDUCTION_SUCCESS,
  CREATE_DEDUCTION_ERROR,
  UPDATE_DEDUCTION_ACTION,
  UPDATE_DEDUCTION_LOADING,
  UPDATE_DEDUCTION_SUCCESS,
  UPDATE_DEDUCTION_ERROR,
  DELETE_DEDUCTION_ACTION,
  DELETE_DEDUCTION_LOADING,
  DELETE_DEDUCTION_SUCCESS,
  DELETE_DEDUCTION_ERROR,
  BONUS_LIST_ACTION,
  BONUS_LIST_LOADING,
  BONUS_LIST_SUCCESS,
  BONUS_LIST_ERROR,
  GET_BONUS_ACTION,
  GET_BONUS_LOADING,
  GET_BONUS_SUCCESS,
  GET_BONUS_ERROR,
  CREATE_BONUS_ACTION,
  CREATE_BONUS_LOADING,
  CREATE_BONUS_SUCCESS,
  CREATE_BONUS_ERROR,
  UPDATE_BONUS_ACTION,
  UPDATE_BONUS_LOADING,
  UPDATE_BONUS_SUCCESS,
  UPDATE_BONUS_ERROR,
  DELETE_BONUS_ACTION,
  DELETE_BONUS_LOADING,
  DELETE_BONUS_SUCCESS,
  DELETE_BONUS_ERROR,
  BONUS_CLAIM_LIST_ACTION,
  BONUS_CLAIM_LIST_LOADING,
  BONUS_CLAIM_LIST_SUCCESS,
  BONUS_CLAIM_LIST_ERROR,
  GET_BONUS_CLAIM_ACTION,
  GET_BONUS_CLAIM_LOADING,
  GET_BONUS_CLAIM_SUCCESS,
  GET_BONUS_CLAIM_ERROR,
  DELETE_BONUS_CLAIM_ACTION,
  DELETE_BONUS_CLAIM_LOADING,
  DELETE_BONUS_CLAIM_SUCCESS,
  DELETE_BONUS_CLAIM_ERROR,
  OVERVIEW_FILTER_ACTION,
  OVERVIEW_FILTER_SUCCESS,
  TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_ACTION,
  TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_SUCCESS,
  TRANSACTIONS_OVERTIME_REQUESTS_FILTER_ACTION,
  TRANSACTIONS_OVERTIME_REQUESTS_FILTER_SUCCESS,
  TRANSACTION_HISTORY_ACTION,
  TRANSACTION_HISTORY_LOADING,
  TRANSACTION_HISTORY_SUCCESS,
  TRANSACTION_HISTORY_ERROR,
  BACKOFFICE_COUNTRY_FEES_LIST_ACTION,
  BACKOFFICE_COUNTRY_FEES_LIST_LOADING,
  BACKOFFICE_COUNTRY_FEES_LIST_SUCCESS,
  BACKOFFICE_COUNTRY_FEES_LIST_ERROR,
  CREATE_COUNTRY_FEES_ACTION,
  CREATE_COUNTRY_FEES_LOADING,
  CREATE_COUNTRY_FEES_SUCCESS,
  CREATE_COUNTRY_FEES_ERROR,
  UPDATE_COUNTRY_FEES_ACTION,
  UPDATE_COUNTRY_FEES_LOADING,
  UPDATE_COUNTRY_FEES_SUCCESS,
  UPDATE_COUNTRY_FEES_ERROR,
  PAYMENT_DOWNLOAD_LOADING,
  PAYMENT_DOWNLOAD_ACTION,
  PAYMENT_DOWNLOAD_SUCCESS,
  PAYMENT_DOWNLOAD_ERROR, PAYMENT_DOWNLOAD_RESET_ACTION,
  PAYMENT_SUB_TABLE_LIST_ACTION,
  PAYMENT_SUB_TABLE_LIST_ERROR,
  PAYMENT_SUB_TABLE_LIST_SUCCESS,
  PAYMENT_SUB_TABLE_LIST_LOADING,
  DECLINE_PAYMENT_ACTION,
  DECLINE_PAYMENT_LOADING,
  DECLINE_PAYMENT_SUCCESS,
  DECLINE_PAYMENT_ERROR,
  GET_REPORTS_ACTION,
  GET_REPORTS_ERROR,
  GET_REPORTS_LOADING,
  GET_REPORTS_SUCCESS,
  PUSH_NOTIFICATION_ACTION,
  PUSH_NOTFICATION_SUCCESS,
  PUSH_NOTIFICATION_ERROR,
  PUSH_NOTIFICATION_LOADING,
  SEND_MONTHLY_COMPANY_REPORTS_ACTION,
  SEND_MONTHLY_COMPANY_REPORTS_LOADING,
  SEND_MONTHLY_COMPANY_REPORTS_ERROR,
  SEND_MONTHLY_COMPANY_REPORTS_SUCCESS,
  SEND_CUSTOM_COMPANY_REPORTS_ACTION,
  SEND_CUSTOM_COMPANY_REPORTS_ERROR,
  SEND_CUSTOM_COMPANY_REPORTS_LOADING,
  SEND_CUSTOM_COMPANY_REPORTS_SUCCESS,
  GET_PAYMENTS_COUNT_ACTION,
  GET_PAYMENTS_COUNT_ERROR,
  GET_PAYMENTS_COUNT_LOADING,
  GET_PAYMENTS_COUNT_SUCCESS,
  UPDATE_COMPANY_PAYMENT_LOADING,
  UPDATE_COMPANY_PAYMENT_ERROR,
  UPDATE_COMPANY_PAYMENT_SUCCESS,
  UPDATE_COMPANY_PAYMENT_ACTION,
  GET_WITHDRAWAL_CATEGORIES_ACTION,
  GET_WITHDRAWAL_CATEGORIES_ERROR,
  GET_WITHDRAWAL_CATEGORIES_LOADING,
  GET_WITHDRAWAL_CATEGORIES_SUCCESS,
  CREATE_WITHDRAWAL_CATEGORY_ACTION,
  CREATE_WITHDRAWAL_CATEGORY_ERROR,
  CREATE_WITHDRAWAL_CATEGORY_LOADING,
  CREATE_WITHDRAWAL_CATEGORY_SUCCESS,
  UPDATE_WITHDRAWAL_CATEGORY_ACTION,
  UPDATE_WITHDRAWAL_CATEGORY_ERROR,
  UPDATE_WITHDRAWAL_CATEGORY_LOADING,
  UPDATE_WITHDRAWAL_CATEGORY_SUCCESS,
  DELETE_WITHDRAWAL_CATEGORY_ACTION,
  DELETE_WITHDRAWAL_CATEGORY_ERROR,
  DELETE_WITHDRAWAL_CATEGORY_LOADING,
  DELETE_WITHDRAWAL_CATEGORY_SUCCESS,
  GET_WITHDRAWAL_CATEGORY_ACTION,
  GET_WITHDRAWAL_CATEGORY_LOADING,
  GET_WITHDRAWAL_CATEGORY_ERROR,
  GET_WITHDRAWAL_CATEGORY_SUCCESS,
  MERCHANT_LIST_ACTION,
  MERCHANT_LIST_LOADING,
  MERCHANT_LIST_SUCCESS,
  MERCHANT_LIST_ERROR,
  GET_MERCHANT_ACTION,
  GET_MERCHANT_LOADING,
  GET_MERCHANT_SUCCESS,
  GET_MERCHANT_ERROR,
  INVITE_MERCHANT_ACTION,
  INVITE_MERCHANT_LOADING,
  INVITE_MERCHANT_SUCCESS,
  INVITE_MERCHANT_ERROR,
  UPDATE_MERCHANT_ACTION,
  REACTIVATE_VENDOR_ACTION,
  REACTIVATE_VENDOR_LOADING,
  REACTIVATE_VENDOR_SUCCESS,
  REACTIVATE_VENDOR_ERROR,
  SUSPEND_VENDOR_ACTION,
  SUSPEND_VENDOR_LOADING,
  SUSPEND_VENDOR_SUCCESS,
  SUSPEND_VENDOR_ERROR,
  UPDATE_MERCHANT_LOADING,
  UPDATE_MERCHANT_SUCCESS,
  UPDATE_MERCHANT_ERROR,
  PROMOTE_HR_TO_ADMIN_ACTION,
  PROMOTE_HR_TO_ADMIN_ERROR,
  PROMOTE_HR_TO_ADMIN_LOADING,
  PROMOTE_HR_TO_ADMIN_SUCCESS,
  GET_USER_ACTIVITY_LOGS_ERROR,
  GET_USER_ACTIVITY_LOGS_SUCCESS,
  GET_USER_ACTIVITY_LOGS_LOADING,
  GET_USER_ACTIVITY_LOGS_ACTION,
  GET_VENDOR_PAYMENTS_ACTION,
  GET_VENDOR_PAYMENTS_LOADING,
  GET_VENDOR_PAYMENTS_SUCCESS,
  GET_VENDOR_PAYMENTS_ERROR,
  GET_VENDOR_FEES_ACTION,
  GET_VENDOR_FEES_LOADING,
  GET_VENDOR_FEES_SUCCESS,
  GET_VENDOR_FEES_ERROR,
  CREATE_VENDOR_FEES_ACTION,
  CREATE_VENDOR_FEES_LOADING,
  CREATE_VENDOR_FEES_SUCCESS,
  CREATE_VENDOR_FEES_ERROR,
  UPDATE_VENDOR_FEES_ACTION,
  UPDATE_VENDOR_FEES_LOADING,
  UPDATE_VENDOR_FEES_SUCCESS,
  UPDATE_VENDOR_FEES_ERROR,
  DELETE_VENDOR_FEES_ACTION,
  DELETE_VENDOR_FEES_LOADING,
  DELETE_VENDOR_FEES_SUCCESS,
  DELETE_VENDOR_FEES_ERROR,
  GET_COMPANY_FEES_ACTION,
  GET_COMPANY_FEES_LOADING,
  GET_COMPANY_FEES_SUCCESS,
  GET_COMPANY_FEES_ERROR,
  CREATE_COMPANY_FEES_ACTION,
  CREATE_COMPANY_FEES_LOADING,
  CREATE_COMPANY_FEES_SUCCESS,
  CREATE_COMPANY_FEES_ERROR,
  UPDATE_COMPANY_FEES_ACTION,
  UPDATE_COMPANY_FEES_LOADING,
  UPDATE_COMPANY_FEES_SUCCESS,
  UPDATE_COMPANY_FEES_ERROR,
  DELETE_COMPANY_FEES_ACTION,
  DELETE_COMPANY_FEES_LOADING,
  DELETE_COMPANY_FEES_SUCCESS,
  DELETE_COMPANY_FEES_ERROR,
  GET_VENDOR_SETTLEMENTS_ACTION,
  GET_VENDOR_SETTLEMENTS_LOADING,
  GET_VENDOR_SETTLEMENTS_SUCCESS,
  GET_VENDOR_SETTLEMENTS_ERROR,
  GET_PAYSTACK_BANKS_LIST_ACTION,
  GET_PAYSTACK_BANKS_LIST_LOADING,
  GET_PAYSTACK_BANKS_LIST_SUCCESS,
  GET_PAYSTACK_BANKS_LIST_ERROR,
  VERIFY_PAYSTACK_BANK_ACCOUNT_ACTION,
  VERIFY_PAYSTACK_BANK_ACCOUNT_LOADING,
  VERIFY_PAYSTACK_BANK_ACCOUNT_SUCCESS,
  VERIFY_PAYSTACK_BANK_ACCOUNT_ERROR,
  ADD_VENDOR_BANK_DETAILS_ACTION,
  ADD_VENDOR_BANK_DETAILS_LOADING,
  ADD_VENDOR_BANK_DETAILS_SUCCESS,
  ADD_VENDOR_BANK_DETAILS_ERROR,
  UPDATE_VENDOR_BANK_DETAILS_ACTION,
  UPDATE_VENDOR_BANK_DETAILS_LOADING,
  UPDATE_VENDOR_BANK_DETAILS_SUCCESS,
  UPDATE_VENDOR_BANK_DETAILS_ERROR,
  DELETE_VENDOR_BANK_DETAILS_ACTION,
  DELETE_VENDOR_BANK_DETAILS_LOADING,
  DELETE_VENDOR_BANK_DETAILS_SUCCESS,
  DELETE_VENDOR_BANK_DETAILS_ERROR,
  GET_VENDOR_BANK_DETAILS_ACTION,
  GET_VENDOR_BANK_DETAILS_LOADING,
  GET_VENDOR_BANK_DETAILS_SUCCESS,
  GET_VENDOR_BANK_DETAILS_ERROR,
  LIST_VENDOR_BANK_DETAILS_ACTION,
  LIST_VENDOR_BANK_DETAILS_LOADING,
  LIST_VENDOR_BANK_DETAILS_SUCCESS,
  LIST_VENDOR_BANK_DETAILS_ERROR,
  VENDOR_SETTLEMENT_TRIGGER_ACTION,
  VENDOR_SETTLEMENT_TRIGGER_ERROR,
  VENDOR_SETTLEMENT_TRIGGER_SUCCESS,
  VENDOR_SETTLEMENT_TRIGGER_LOADING,
  VENDOR_RESEND_INVITATION_ACTION,
  VENDOR_RESEND_INVITATION_ERROR,
  VENDOR_RESEND_INVITATION_SUCCESS,
  VENDOR_RESEND_INVITATION_LOADING,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ACTION,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ERROR,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_SUCCESS,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_LOADING,
  ONBOARD_COMPANY_EMPLOYEES_ACTION,
  ONBOARD_COMPANY_EMPLOYEES_ERROR,
  ONBOARD_COMPANY_EMPLOYEES_SUCCESS,
  ONBOARD_COMPANY_EMPLOYEES_LOADING,
  CAMPAIGN_CONFIG_REQUEST_ACTION,
  CAMPAIGN_CONFIG_REQUEST_LOADING,
  CAMPAIGN_CONFIG_REQUEST_SUCCESS,
  CAMPAIGN_CONFIG_REQUEST_ERROR,
  CAMPAIGN_LIST_REQUEST_ACTION,
  CAMPAIGN_LIST_REQUEST_LOADING,
  CAMPAIGN_LIST_REQUEST_SUCCESS,
  CAMPAIGN_LIST_REQUEST_ERROR,
  CAMPAIGN_DETAIL_REQUEST_ACTION,
  CAMPAIGN_DETAIL_REQUEST_LOADING,
  CAMPAIGN_DETAIL_REQUEST_SUCCESS,
  CAMPAIGN_DETAIL_REQUEST_ERROR,
  CAMPAIGN_CREATE_REQUEST_ACTION,
  CAMPAIGN_CREATE_REQUEST_LOADING,
  CAMPAIGN_CREATE_REQUEST_SUCCESS,
  CAMPAIGN_CREATE_REQUEST_ERROR,
  CAMPAIGN_UPDATE_REQUEST_ACTION,
  CAMPAIGN_UPDATE_REQUEST_LOADING,
  CAMPAIGN_UPDATE_REQUEST_SUCCESS,
  CAMPAIGN_UPDATE_REQUEST_ERROR,
  CAMPAIGN_ACTION_REQUEST_ACTION,
  CAMPAIGN_ACTION_REQUEST_LOADING,
  CAMPAIGN_ACTION_REQUEST_SUCCESS,
  CAMPAIGN_ACTION_REQUEST_ERROR,
  CAMPAIGN_STATS_REQUEST_ACTION,
  CAMPAIGN_STATS_REQUEST_LOADING,
  CAMPAIGN_STATS_REQUEST_SUCCESS,
  CAMPAIGN_STATS_REQUEST_ERROR,
  CAMPAIGN_HISTORY_REQUEST_ACTION,
  CAMPAIGN_HISTORY_REQUEST_LOADING,
  CAMPAIGN_HISTORY_REQUEST_SUCCESS,
  CAMPAIGN_HISTORY_REQUEST_ERROR,
  CAMPAIGN_SET_FILTERS_ACTION,
  CAMPAIGN_SET_FILTERS_SUCCESS,
  CAMPAIGN_SET_PAGINATION_ACTION,
  CAMPAIGN_SET_PAGINATION_SUCCESS,
  CAMPAIGN_SET_HISTORY_PAGINATION_ACTION,
  CAMPAIGN_SET_HISTORY_PAGINATION_SUCCESS,
  CAMPAIGN_RESET_FORM_ERRORS_ACTION,
  CAMPAIGN_RESET_FORM_ERRORS_SUCCESS,
  CAMPAIGN_CLEAR_TOAST_ACTION,
  CAMPAIGN_CLEAR_TOAST_SUCCESS,
  PERMISSION_CATALOGUE_ACTION,
  PERMISSION_CATALOGUE_LOADING,
  PERMISSION_CATALOGUE_SUCCESS,
  PERMISSION_CATALOGUE_ERROR,
  GROUP_LIST_ACTION,
  GROUP_LIST_LOADING,
  GROUP_LIST_SUCCESS,
  GROUP_LIST_ERROR,
  GET_GROUP_ACTION,
  GET_GROUP_LOADING,
  GET_GROUP_SUCCESS,
  GET_GROUP_ERROR,
  CREATE_GROUP_ACTION,
  CREATE_GROUP_LOADING,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_ERROR,
  UPDATE_GROUP_ACTION,
  UPDATE_GROUP_LOADING,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_ERROR,
  DELETE_GROUP_ACTION,
  DELETE_GROUP_LOADING,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_ERROR,
  GROUP_MEMBER_LIST_ACTION,
  GROUP_MEMBER_LIST_LOADING,
  GROUP_MEMBER_LIST_SUCCESS,
  GROUP_MEMBER_LIST_ERROR,
  ADD_GROUP_MEMBERS_ACTION,
  ADD_GROUP_MEMBERS_LOADING,
  ADD_GROUP_MEMBERS_SUCCESS,
  ADD_GROUP_MEMBERS_ERROR,
  REMOVE_GROUP_MEMBERS_ACTION,
  REMOVE_GROUP_MEMBERS_LOADING,
  REMOVE_GROUP_MEMBERS_SUCCESS,
  REMOVE_GROUP_MEMBERS_ERROR,
  NOTIFICATION_COUNT_ACTION,
  NOTIFICATION_COUNT_SUCCESS,
  NOTIFICATION_COUNT_ERROR,
  NOTIFICATION_LIST_ACTION,
  NOTIFICATION_LIST_LOADING,
  NOTIFICATION_LIST_SUCCESS,
  NOTIFICATION_LIST_ERROR,
  MARK_NOTIFICATION_READ_ACTION,
  MARK_NOTIFICATION_READ_SUCCESS,
  MARK_NOTIFICATION_READ_ERROR,
  MARK_ALL_NOTIFICATIONS_READ_ACTION,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_ERROR,
  GET_FORTRESS_COMPANIES_ACTION,
  GET_FORTRESS_COMPANIES_LOADING,
  GET_FORTRESS_COMPANIES_SUCCESS,
  GET_FORTRESS_COMPANIES_ERROR,
  UPDATE_FORTRESS_COMPANIES_ACTION,
  UPDATE_FORTRESS_COMPANIES_LOADING,
  UPDATE_FORTRESS_COMPANIES_SUCCESS,
  UPDATE_FORTRESS_COMPANIES_ERROR,
  FORTRESS_BANK_CODE_LIST_ACTION,
  FORTRESS_BANK_CODE_LIST_LOADING,
  FORTRESS_BANK_CODE_LIST_SUCCESS,
  FORTRESS_BANK_CODE_LIST_ERROR,
  UPDATE_FORTRESS_BANK_CODE_ACTION,
  UPDATE_FORTRESS_BANK_CODE_LOADING,
  UPDATE_FORTRESS_BANK_CODE_SUCCESS,
  UPDATE_FORTRESS_BANK_CODE_ERROR,
  DOWNLOAD_EMPLOYEE_STATEMENT_ACTION,
  DOWNLOAD_EMPLOYEE_STATEMENT_LOADING,
  DOWNLOAD_EMPLOYEE_STATEMENT_SUCCESS,
  DOWNLOAD_EMPLOYEE_STATEMENT_ERROR,
} from "./types";

import Api from "./api";
import { normalizeCampaignConfig, buildCampaignPayload } from "./campaignUtils";
// import { GET_COMPANY_PAYMENT_ACTION } from "../companyDashboard/types";

function* getPaymentListSaga(data) {
  yield put({ type: PAYMENT_LIST_LOADING });
  try {
    let res = yield call(Api.getPaymentList, data.payload);
    if (res.message) {
      yield put({ type: PAYMENT_LIST_ERROR, payload: res.message });
    } else yield put({ type: PAYMENT_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: PAYMENT_LIST_ERROR, payload: error.message });
  }
}

function* getPaymentDownloadSaga(data) {
  yield put({ type: PAYMENT_DOWNLOAD_LOADING });
  try {
    let res = yield call(Api.getPaymentDownload, data);

    if (res?.data instanceof Blob) {
      const filename =
        parseDispositionFilename(res?.headers) || `payment-history-${data.company_id ? data.company_id : "all"}.xlsx`;
      triggerBlobDownload(res.data, filename);
      yield put({ type: PAYMENT_DOWNLOAD_SUCCESS, payload: { filename } });
    }else if (res.message) {
      yield put({ type: PAYMENT_LIST_ERROR, payload: res.message });
    } else yield put({ type: PAYMENT_DOWNLOAD_SUCCESS, payload: res, filename: `payment-history-${data.company_id ? data.company_id : "all"}.xlsx` });
  } catch (error) {
    yield put({ type: PAYMENT_DOWNLOAD_ERROR, payload: error.message });
  }
}

function* getPaymentWDSaga(data) {
  yield put({ type: PAYMENT_SUB_TABLE_LIST_LOADING });
  try {
    let res = yield call(Api.getPaymentWDList, {
      company_id: data?.payload?.company_id,
      page_size: 20,
      page: data?.payload?.page
    });
    if (res.message) {
      yield put({
        type: PAYMENT_SUB_TABLE_LIST_ERROR, payload: res.message
      });
    } else yield put({
      type: PAYMENT_SUB_TABLE_LIST_SUCCESS, payload: {
        ...res, paymentSubTablePage: data?.payload?.page
      }
    });
  } catch (error) {
    yield put({ type: PAYMENT_DOWNLOAD_ERROR, payload: error.message });
  }
}

function* resetPaymentDownloadSaga() {
  yield put({ type: PAYMENT_DOWNLOAD_SUCCESS, payload: null, filename: null });
}

function* getPaymentInfoSaga(data) {
  yield put({ type: GET_PAYMENT_LOADING });
  try {
    let res = yield call(Api.getPaymentInfo, data.payment_id);
    if (res.message) {
      yield put({ type: GET_PAYMENT_ERROR, payload: res.message });
    } else yield put({ type: GET_PAYMENT_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: GET_PAYMENT_ERROR, payload: error.message });
  }
}

function* settlePaymentSaga(data) {
  yield put({ type: SETTLE_PAYMENT_LOADING });
  try {
    let res = yield call(Api.settlePayment, data.payload, data.payment_id);
    if (res.message) {
      yield put({ type: SETTLE_PAYMENT_ERROR, payload: res.message });
    } else yield put({ type: SETTLE_PAYMENT_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: SETTLE_PAYMENT_ERROR, payload: error.message });
  }
}

function* getMonthsToSettleSaga(data) {
  yield put({ type: MONTHS_TO_SETTLE_LOADING });
  try {
    let res = yield call(Api.getMonthsToSettle, data.employee_id);
    if (res.message) {
      yield put({ type: MONTHS_TO_SETTLE_ERROR, payload: res.message });
    } else yield put({ type: MONTHS_TO_SETTLE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: MONTHS_TO_SETTLE_ERROR, payload: error.message });
  }
}

function* getBulkMonthsToSettleSaga(data) {
  yield put({ type: BULK_MONTHS_TO_SETTLE_LOADING });
  try {
    let res = yield call(Api.getBulkMonthsToSettle, data.country);
    if (res.message) {
      yield put({ type: BULK_MONTHS_TO_SETTLE_ERROR, payload: res.message });
    } else yield put({ type: BULK_MONTHS_TO_SETTLE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: BULK_MONTHS_TO_SETTLE_ERROR, payload: error.message });
  }
}

function* settleSalarySaga(data) {
  yield put({ type: SETTLE_SALARY_LOADING });
  try {
    let res = yield call(Api.settleSalary, data.employee_id, data.month);
    if (res.message) {
      yield put({ type: SETTLE_SALARY_ERROR, payload: res.message });
    } else yield put({ type: SETTLE_SALARY_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: SETTLE_SALARY_ERROR, payload: error.message });
  }
}

function* bulkSettleSalarySaga(data) {
  yield put({ type: BULK_SETTLE_SALARY_LOADING });
  try {
    let res = yield call(Api.bulkSettleSalary, data.employees_ids, data.month);
    if (res.message) {
      yield put({ type: BULK_SETTLE_SALARY_ERROR, payload: res.message });
    } else yield put({ type: BULK_SETTLE_SALARY_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: BULK_SETTLE_SALARY_ERROR, payload: error.message });
  }
}

function* getCompanyListSaga(data) {
  yield put({ type: COMPANY_LIST_LOADING });
  try {
    let res = yield call(Api.getCompanyList, data.payload);
    if (res.message) {
      yield put({ type: COMPANY_LIST_ERROR, payload: res.message });
    } else yield put({ type: COMPANY_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: COMPANY_LIST_ERROR, payload: error.message });
  }
}

function* getCompanyInfoSaga(data) {
  yield put({ type: GET_COMPANY_LOADING });
  try {
    let res = yield call(Api.getCompanyInfo, data.company_id);
    if (res.message) {
      yield put({ type: GET_COMPANY_ERROR, payload: res.message });
    } else yield put({ type: GET_COMPANY_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: GET_COMPANY_ERROR, payload: error.message });
  }
}

function* getEmployeeListSaga(data) {
  yield put({ type: EMPLOYEE_LIST_LOADING });
  try {
    let res = yield call(Api.getEmployeeList, data.payload);
    if (res.message) {
      yield put({ type: EMPLOYEE_LIST_ERROR, payload: res.message });
    } else yield put({ type: EMPLOYEE_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: EMPLOYEE_LIST_ERROR, payload: error.message });
  }
}

function* getEmployeeInfoSaga(data) {
  yield put({ type: GET_EMPLOYEE_LOADING });
  try {
    let res = yield call(Api.getEmployeeInfo, data.employee_id);
    if (res.message) {
      yield put({ type: GET_EMPLOYEE_ERROR, payload: res.message });
    } else yield put({ type: GET_EMPLOYEE_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: GET_EMPLOYEE_ERROR, payload: error.message });
  }
}

function* getOverviewSaga(data) {
  yield put({ type: OVERVIEW_LOADING });
  try {
    let res = yield call(Api.getOverview, data.payload);
    if (res.message) {
      yield put({ type: OVERVIEW_ERROR, payload: res.message });
    } else yield put({ type: OVERVIEW_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: OVERVIEW_ERROR, payload: error.message });
  }
}

function* inviteCompanySaga(data) {
  yield put({ type: INVITE_COMPANY_LOADING });
  try {
    let res = yield call(Api.inviteCompany, data.payload);
    if (res.message) {
      yield put({ type: INVITE_COMPANY_ERROR, payload: res.message });
    } else yield put({ type: INVITE_COMPANY_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: INVITE_COMPANY_ERROR, payload: error.message });
  }
}

function* updateCompanySaga(data) {
  yield put({ type: UPDATE_COMPANY_LOADING });
  try {
    let res = yield call(Api.updateCompany, data.payload);
    if (res.message) {
      yield put({ type: UPDATE_COMPANY_ERROR, payload: res.message });
    } else yield put({ type: UPDATE_COMPANY_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: UPDATE_COMPANY_ERROR, payload: error.message });
  }
}

function* getExchangeListSaga(data) {
  yield put({ type: EXCHANGE_LIST_LOADING });
  try {
    let res = yield call(Api.getExchangeList, data.payload);
    if (res.message) {
      yield put({ type: EXCHANGE_LIST_ERROR, payload: res.message });
    } else yield put({ type: EXCHANGE_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: EXCHANGE_LIST_ERROR, payload: error.message });
  }
}

function* getExchangeInfoSaga(data) {
  yield put({ type: GET_EXCHANGE_LOADING });
  try {
    let res = yield call(Api.getExchangeInfo, data.exchange_id);
    if (res.message) {
      yield put({ type: GET_EXCHANGE_ERROR, payload: res.message });
    } else yield put({ type: GET_EXCHANGE_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: GET_EXCHANGE_ERROR, payload: error.message });
  }
}

function* createExchangeSaga(data) {
  yield put({ type: CREATE_EXCHANGE_LOADING });
  try {
    let res = yield call(Api.createExchange, data.payload);
    if (res.message) {
      yield put({ type: CREATE_EXCHANGE_ERROR, payload: res.message });
    } else yield put({ type: CREATE_EXCHANGE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: CREATE_EXCHANGE_ERROR, payload: error.message });
  }
}

function* updateExchangeSaga(data) {
  yield put({ type: UPDATE_EXCHANGE_LOADING });
  try {
    let res = yield call(Api.updateExchange, data.payload, data.exchange_id);
    if (res.message) {
      yield put({ type: UPDATE_EXCHANGE_ERROR, payload: res.message });
    } else yield put({ type: UPDATE_EXCHANGE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: UPDATE_EXCHANGE_ERROR, payload: error.message });
  }
}

function* deleteExchangeSaga(data) {
  yield put({ type: DELETE_EXCHANGE_LOADING });
  try {
    let res = yield call(Api.deleteExchange, data.exchange_id);
    if (res.message) {
      yield put({ type: DELETE_EXCHANGE_ERROR, payload: res.message });
    } else yield put({ type: DELETE_EXCHANGE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: DELETE_EXCHANGE_ERROR, payload: error.message });
  }
}

function* getDeductionListSaga(data) {
  yield put({ type: BACKOFFICE_DEDUCTION_LIST_LOADING });
  try {
    let res = yield call(Api.getDeductionList, data.payload);
    if (res.message) {
      yield put({
        type: BACKOFFICE_DEDUCTION_LIST_ERROR,
        payload: res.message,
      });
    } else yield put({ type: BACKOFFICE_DEDUCTION_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({
      type: BACKOFFICE_DEDUCTION_LIST_ERROR,
      payload: error.message,
    });
  }
}

function* getDeductionInfoSaga(data) {
  yield put({ type: GET_DEDUCTION_LOADING });
  try {
    let res = yield call(Api.getDeductionInfo, data.deduction_id);
    if (res.message) {
      yield put({ type: GET_DEDUCTION_ERROR, payload: res.message });
    } else yield put({ type: GET_DEDUCTION_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: GET_DEDUCTION_ERROR, payload: error.message });
  }
}

function* createDeductionSaga(data) {
  yield put({ type: CREATE_DEDUCTION_LOADING });
  try {
    let res = yield call(Api.createDeduction, data.payload);
    if (res.message) {
      yield put({ type: CREATE_DEDUCTION_ERROR, payload: res.message });
    } else yield put({ type: CREATE_DEDUCTION_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: CREATE_DEDUCTION_ERROR, payload: error.message });
  }
}

function* updateDeductionSaga(data) {
  yield put({ type: UPDATE_DEDUCTION_LOADING });
  try {
    let res = yield call(Api.updateDeduction, data.payload, data.deduction_id);
    if (res.message) {
      yield put({ type: UPDATE_DEDUCTION_ERROR, payload: res.message });
    } else yield put({ type: UPDATE_DEDUCTION_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: UPDATE_DEDUCTION_ERROR, payload: error.message });
  }
}

function* deleteDeductionSaga(data) {
  yield put({ type: DELETE_DEDUCTION_LOADING });
  try {
    let res = yield call(Api.deleteDeduction, data.deduction_id);
    if (res.message) {
      yield put({ type: DELETE_DEDUCTION_ERROR, payload: res.message });
    } else yield put({ type: DELETE_DEDUCTION_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: DELETE_DEDUCTION_ERROR, payload: error.message });
  }
}

/* -------------------------------- Bonuses -------------------------------- */
// The axios interceptor (lib/axiosConfig) resolves failed requests into an
// envelope { code, message: string[], details } rather than throwing, so a
// truthy `res.message` signals an error — matching the convention used above.
function* getBonusListSaga(data) {
  yield put({ type: BONUS_LIST_LOADING });
  try {
    let res = yield call(Api.getBonusList, data.payload);
    if (res.message) {
      yield put({ type: BONUS_LIST_ERROR, payload: res.message });
    } else yield put({ type: BONUS_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: BONUS_LIST_ERROR, payload: error.message });
  }
}

function* getBonusInfoSaga(data) {
  yield put({ type: GET_BONUS_LOADING });
  try {
    let res = yield call(Api.getBonusInfo, data.bonus_id);
    if (res.message) {
      yield put({ type: GET_BONUS_ERROR, payload: res.message });
    } else yield put({ type: GET_BONUS_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: GET_BONUS_ERROR, payload: error.message });
  }
}

function* createBonusSaga(data) {
  yield put({ type: CREATE_BONUS_LOADING });
  try {
    let res = yield call(Api.createBonus, data.payload);
    if (res.message) {
      // res.details carries the field -> errors map for 400 validation errors.
      yield put({
        type: CREATE_BONUS_ERROR,
        payload: res.message,
        fieldErrors: res.details || null,
      });
    } else yield put({ type: CREATE_BONUS_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: CREATE_BONUS_ERROR, payload: error.message });
  }
}

function* updateBonusSaga(data) {
  yield put({ type: UPDATE_BONUS_LOADING });
  try {
    let res = yield call(Api.updateBonus, data.payload, data.bonus_id);
    if (res.message) {
      yield put({
        type: UPDATE_BONUS_ERROR,
        payload: res.message,
        fieldErrors: res.details || null,
      });
    } else yield put({ type: UPDATE_BONUS_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: UPDATE_BONUS_ERROR, payload: error.message });
  }
}

function* deleteBonusSaga(data) {
  yield put({ type: DELETE_BONUS_LOADING });
  try {
    let res = yield call(Api.deleteBonus, data.bonus_id);
    // A 204 resolves to an empty body; only a truthy message means failure
    // (e.g. the server rejects deleting a bonus that already has claims).
    if (res && res.message) {
      yield put({ type: DELETE_BONUS_ERROR, payload: res.message });
    } else yield put({ type: DELETE_BONUS_SUCCESS, payload: data.bonus_id });
  } catch (error) {
    yield put({ type: DELETE_BONUS_ERROR, payload: error.message });
  }
}

/* --------------------------------- Claims -------------------------------- */
function* getBonusClaimListSaga(data) {
  yield put({ type: BONUS_CLAIM_LIST_LOADING });
  try {
    let res = yield call(Api.getBonusClaimList, data.payload);
    if (res.message) {
      yield put({ type: BONUS_CLAIM_LIST_ERROR, payload: res.message });
    } else yield put({ type: BONUS_CLAIM_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: BONUS_CLAIM_LIST_ERROR, payload: error.message });
  }
}

function* getBonusClaimInfoSaga(data) {
  yield put({ type: GET_BONUS_CLAIM_LOADING });
  try {
    let res = yield call(Api.getBonusClaimInfo, data.claim_id);
    if (res.message) {
      yield put({ type: GET_BONUS_CLAIM_ERROR, payload: res.message });
    } else yield put({ type: GET_BONUS_CLAIM_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: GET_BONUS_CLAIM_ERROR, payload: error.message });
  }
}

function* deleteBonusClaimSaga(data) {
  yield put({ type: DELETE_BONUS_CLAIM_LOADING });
  try {
    let res = yield call(Api.deleteBonusClaim, data.claim_id);
    if (res && res.message) {
      yield put({ type: DELETE_BONUS_CLAIM_ERROR, payload: res.message });
    } else yield put({ type: DELETE_BONUS_CLAIM_SUCCESS, payload: data.claim_id });
  } catch (error) {
    yield put({ type: DELETE_BONUS_CLAIM_ERROR, payload: error.message });
  }
}

/* ------------------------------ Role Groups ------------------------------ */
// A single group / member array is returned bare (DRF style), so unwrap defensively.
const unwrapGroup = (res) => (res && res.data ? res.data : res);
const unwrapMemberArray = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.results)) return res.results;
  return [];
};

function* getPermissionCatalogueSaga() {
  yield put({ type: PERMISSION_CATALOGUE_LOADING });
  try {
    let res = yield call(Api.getPermissionCatalogue);
    if (res && res.message && !Array.isArray(res)) {
      yield put({ type: PERMISSION_CATALOGUE_ERROR, payload: res.message });
    } else {
      const items = Array.isArray(res) ? res : res?.data || [];
      yield put({ type: PERMISSION_CATALOGUE_SUCCESS, payload: items });
    }
  } catch (error) {
    yield put({ type: PERMISSION_CATALOGUE_ERROR, payload: error.message });
  }
}

function* getGroupListSaga(data) {
  yield put({ type: GROUP_LIST_LOADING });
  try {
    let res = yield call(Api.getGroupList, data.payload);
    if (res && res.message) {
      yield put({ type: GROUP_LIST_ERROR, payload: res.message });
    } else yield put({ type: GROUP_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: GROUP_LIST_ERROR, payload: error.message });
  }
}

function* getGroupSaga(data) {
  yield put({ type: GET_GROUP_LOADING });
  try {
    let res = yield call(Api.getGroup, data.group_id);
    if (res && res.message) {
      yield put({ type: GET_GROUP_ERROR, payload: res.message });
    } else yield put({ type: GET_GROUP_SUCCESS, payload: unwrapGroup(res) });
  } catch (error) {
    yield put({ type: GET_GROUP_ERROR, payload: error.message });
  }
}

function* createGroupSaga(data) {
  yield put({ type: CREATE_GROUP_LOADING });
  try {
    let res = yield call(Api.createGroup, data.payload);
    if (res && res.message) {
      yield put({
        type: CREATE_GROUP_ERROR,
        payload: res.message,
        fieldErrors: res.details || null,
      });
    } else yield put({ type: CREATE_GROUP_SUCCESS, payload: unwrapGroup(res) });
  } catch (error) {
    yield put({ type: CREATE_GROUP_ERROR, payload: error.message });
  }
}

function* updateGroupSaga(data) {
  yield put({ type: UPDATE_GROUP_LOADING });
  try {
    let res = yield call(Api.updateGroup, data.payload, data.group_id);
    if (res && res.message) {
      yield put({
        type: UPDATE_GROUP_ERROR,
        payload: res.message,
        fieldErrors: res.details || null,
      });
    } else yield put({ type: UPDATE_GROUP_SUCCESS, payload: unwrapGroup(res) });
  } catch (error) {
    yield put({ type: UPDATE_GROUP_ERROR, payload: error.message });
  }
}

function* deleteGroupSaga(data) {
  yield put({ type: DELETE_GROUP_LOADING });
  try {
    let res = yield call(Api.deleteGroup, data.group_id);
    if (res && res.message) {
      yield put({ type: DELETE_GROUP_ERROR, payload: res.message });
    } else yield put({ type: DELETE_GROUP_SUCCESS, payload: data.group_id });
  } catch (error) {
    yield put({ type: DELETE_GROUP_ERROR, payload: error.message });
  }
}

function* getGroupMembersSaga(data) {
  yield put({ type: GROUP_MEMBER_LIST_LOADING });
  try {
    let res = yield call(Api.getGroupMembers, data.payload, data.group_id);
    if (res && res.message) {
      yield put({ type: GROUP_MEMBER_LIST_ERROR, payload: res.message });
    } else yield put({ type: GROUP_MEMBER_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: GROUP_MEMBER_LIST_ERROR, payload: error.message });
  }
}

function* addGroupMembersSaga(data) {
  yield put({ type: ADD_GROUP_MEMBERS_LOADING });
  try {
    let res = yield call(Api.addGroupMembers, data.payload, data.group_id);
    // A non-array object with a message is an error; success is the full member array.
    if (res && res.message && !Array.isArray(res)) {
      yield put({ type: ADD_GROUP_MEMBERS_ERROR, payload: res.message });
    } else {
      yield put({ type: ADD_GROUP_MEMBERS_SUCCESS, payload: unwrapMemberArray(res) });
    }
  } catch (error) {
    yield put({ type: ADD_GROUP_MEMBERS_ERROR, payload: error.message });
  }
}

function* removeGroupMembersSaga(data) {
  yield put({ type: REMOVE_GROUP_MEMBERS_LOADING });
  try {
    let res = yield call(Api.removeGroupMembers, data.payload, data.group_id);
    if (res && res.message && !Array.isArray(res)) {
      yield put({ type: REMOVE_GROUP_MEMBERS_ERROR, payload: res.message });
    } else {
      yield put({ type: REMOVE_GROUP_MEMBERS_SUCCESS, payload: unwrapMemberArray(res) });
    }
  } catch (error) {
    yield put({ type: REMOVE_GROUP_MEMBERS_ERROR, payload: error.message });
  }
}

/* ------------------------- Notifications ------------------------------- */
function* getNotificationCountSaga() {
  try {
    let res = yield call(Api.getNotificationCount);
    if (res && res.message) {
      yield put({ type: NOTIFICATION_COUNT_ERROR, payload: res.message });
    } else {
      // Envelope may be { data: {...} } or the bare { unread, total }.
      const payload = res && res.data ? res.data : res;
      yield put({ type: NOTIFICATION_COUNT_SUCCESS, payload });
    }
  } catch (error) {
    yield put({ type: NOTIFICATION_COUNT_ERROR, payload: error.message });
  }
}

function* getNotificationsSaga(data) {
  yield put({ type: NOTIFICATION_LIST_LOADING });
  try {
    let res = yield call(Api.getNotifications, data.payload);
    if (res && res.message) {
      yield put({ type: NOTIFICATION_LIST_ERROR, payload: res.message });
    } else {
      // Carry the append flag so the reducer concatenates (infinite scroll)
      // instead of replacing the feed.
      yield put({ type: NOTIFICATION_LIST_SUCCESS, payload: res, append: data.append });
    }
  } catch (error) {
    yield put({ type: NOTIFICATION_LIST_ERROR, payload: error.message });
  }
}

function* markNotificationReadSaga(data) {
  try {
    let res = yield call(Api.markNotificationRead, data.notification_id);
    if (res && res.message) {
      yield put({ type: MARK_NOTIFICATION_READ_ERROR, payload: res.message });
    } else {
      const payload = res && res.data ? res.data : res;
      yield put({ type: MARK_NOTIFICATION_READ_SUCCESS, payload });
      // Reconcile the badge with the server.
      yield put({ type: NOTIFICATION_COUNT_ACTION });
    }
  } catch (error) {
    yield put({ type: MARK_NOTIFICATION_READ_ERROR, payload: error.message });
  }
}

function* markAllNotificationsReadSaga() {
  try {
    let res = yield call(Api.markAllNotificationsRead);
    if (res && res.message) {
      yield put({ type: MARK_ALL_NOTIFICATIONS_READ_ERROR, payload: res.message });
    } else {
      const payload = res && res.data ? res.data : res;
      yield put({ type: MARK_ALL_NOTIFICATIONS_READ_SUCCESS, payload });
      yield put({ type: NOTIFICATION_COUNT_ACTION });
    }
  } catch (error) {
    yield put({ type: MARK_ALL_NOTIFICATIONS_READ_ERROR, payload: error.message });
  }
}

// Trigger a browser download for a Blob. Kept local to the saga so it doesn't
// pull the component-heavy utils module into the store's dependency graph.
function triggerBlobDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

// Parse a Content-Disposition header for the attachment filename. Handles both
// `filename="x.pdf"` and RFC 5987 `filename*=UTF-8''x.pdf`. Axios lowercases
// header keys, but we check both spellings defensively.
function parseDispositionFilename(headers = {}) {
  const disposition =
    headers["content-disposition"] || headers["Content-Disposition"] || "";
  const star = disposition.match(/filename\*=(?:UTF-8'')?"?([^";\n]+)"?/i);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].trim());
    } catch (e) {
      return star[1].trim();
    }
  }
  const plain = disposition.match(/filename="?([^";\n]+)"?/i);
  if (plain?.[1]) return plain[1].trim();
  return null;
}

function* downloadEmployeeStatementSaga(action) {
  yield put({ type: DOWNLOAD_EMPLOYEE_STATEMENT_LOADING });
  try {
    const res = yield call(Api.downloadEmployeePaymentStatement, action.payload);

    if (res?.data instanceof Blob) {
      const filename =
        parseDispositionFilename(res?.headers) || "payment-statement.pdf";
      triggerBlobDownload(res.data, filename);
      yield put({ type: DOWNLOAD_EMPLOYEE_STATEMENT_SUCCESS, payload: { filename } });
      return;
    }

    const status = res?.status || 0;
    const body = res?.data || {};
    const details =
      body?.details && typeof body.details === "object" ? body.details : {};
    let messages = [];
    if (Array.isArray(body?.message)) messages = body.message.filter(Boolean);
    else if (typeof body?.message === "string" && body.message) messages = [body.message];

    if (!messages.length && !Object.keys(details).length) {
      messages = [
        status === 403
          ? "You don't have permission to download this statement."
          : status === 404
            ? "Employee not found."
            : "Unable to download the statement. Please try again.",
      ];
    }

    yield put({
      type: DOWNLOAD_EMPLOYEE_STATEMENT_ERROR,
      payload: { messages, details, status },
    });
  } catch (error) {
    yield put({
      type: DOWNLOAD_EMPLOYEE_STATEMENT_ERROR,
      payload: { messages: [error.message || "Network error."], details: {}, status: 0 },
    });
  }
}

function* setOverviewFilters(data) {
  yield put({ type: OVERVIEW_FILTER_SUCCESS, payload: data.payload });
}

function* setWithdrawalRequestsFilters(data) {
  yield put({
    type: TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_SUCCESS,
    payload: data.payload,
  });
}

function* setOvertimeRequestsFilters(data) {
  yield put({
    type: TRANSACTIONS_OVERTIME_REQUESTS_FILTER_SUCCESS,
    payload: data.payload,
  });
}

function* transactionHistorySaga(data) {
  yield put({ type: TRANSACTION_HISTORY_LOADING });
  try {
    let res = yield call(Api.getTransactionHistory, data.payload);
    if (res.message) {
      yield put({ type: TRANSACTION_HISTORY_ERROR, payload: res.message });
    } else yield put({ type: TRANSACTION_HISTORY_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: TRANSACTION_HISTORY_ERROR, payload: error.message });
  }
}

function* getCountryListSaga(data) {
  yield put({ type: BACKOFFICE_COUNTRY_FEES_LIST_LOADING });
  try {
    let res = yield call(Api.getFeesList, data.payload);
    if (res.message) {
      yield put({
        type: BACKOFFICE_COUNTRY_FEES_LIST_ERROR,
        payload: res.message,
      });
    } else
      yield put({
        type: BACKOFFICE_COUNTRY_FEES_LIST_SUCCESS,
        payload: res,
      });
  } catch (error) {
    yield put({
      type: BACKOFFICE_COUNTRY_FEES_LIST_ERROR,
      payload: error.message,
    });
  }
}

function* createCountryFeesSaga(data) {
  yield put({ type: CREATE_COUNTRY_FEES_LOADING });
  try {
    let res = yield call(Api.createFees, data.payload);
    if (res.message) {
      yield put({ type: CREATE_COUNTRY_FEES_ERROR, payload: res.message });
    } else yield put({ type: CREATE_COUNTRY_FEES_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: CREATE_COUNTRY_FEES_ERROR, payload: error.message });
  }
}

function* updateCountryFeesSaga(data) {
  yield put({ type: UPDATE_COUNTRY_FEES_LOADING });
  try {
    let res = yield call(Api.updateFees, data.payload);
    if (res.message) {
      yield put({ type: UPDATE_COUNTRY_FEES_ERROR, payload: res.message });
    } else yield put({ type: UPDATE_COUNTRY_FEES_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: UPDATE_COUNTRY_FEES_ERROR, payload: error.message });
  }
}

function* declineWithdrawalPaymentSaga(data) {
  yield put({ type: DECLINE_PAYMENT_LOADING });
  try {
    let res = yield call(Api.declinePayment, data.payload, data?.payment_id);
    if (res.message) {
      yield put({ type: DECLINE_PAYMENT_ERROR, payload: res.message });
    } else yield put({ type: DECLINE_PAYMENT_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: DECLINE_PAYMENT_ERROR, payload: error.message });
  }
}

function* getReportAnalysisSaga(data) {
  yield put({ type: GET_REPORTS_LOADING, payload: data?.payload });
  try {
    let res = yield call(Api.getAnalysisReports, data?.reportsType, data?.payload);
    if (res.message) {
      yield put({ type: GET_REPORTS_ERROR, payload: res.message });
    } else yield put({ type: GET_REPORTS_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: GET_REPORTS_ERROR, payload: error.message });
  }
}

function* pushNotificationSaga(data) {
  yield put({ type: PUSH_NOTIFICATION_LOADING });
  try {
    let res = yield call(Api.pushNotification, data.payload);
    if (res.message) {
      yield put({ type: PUSH_NOTIFICATION_ERROR, payload: res.message });
    } else yield put({ type: PUSH_NOTFICATION_SUCCESS, payload: res })

  } catch (error) {
    yield put({ type: PUSH_NOTIFICATION_ERROR, payload: error.message })
  }
}

function* sendMonthlyCompanyReportsSaga(data) {
  yield put({ type: SEND_MONTHLY_COMPANY_REPORTS_LOADING });
  try {
    let res = yield call(Api.sendCompanyMonthlyReports, data.payload);
    if (res.message) {
      yield put({ type: SEND_MONTHLY_COMPANY_REPORTS_ERROR, payload: res.message })
    } else yield put({ type: SEND_MONTHLY_COMPANY_REPORTS_SUCCESS, payload: res })
  } catch (error) {
    yield put({ type: SEND_MONTHLY_COMPANY_REPORTS_ERROR, payload: error.message })
  }
}

function* sendCustomCompanyReportsSaga(data) {
  yield put({ type: SEND_CUSTOM_COMPANY_REPORTS_LOADING });
  try {
    let res = yield call(Api.sendCompanyCustomReports, data.payload);
    if (res.message) {
      yield put({ type: SEND_CUSTOM_COMPANY_REPORTS_ERROR, payload: res.message })
    } else yield put({ type: SEND_CUSTOM_COMPANY_REPORTS_SUCCESS, payload: res })
  } catch (error) {
    yield put({ type: SEND_CUSTOM_COMPANY_REPORTS_ERROR, payload: error.message })
  }
}

function* getPaymentCountSaga(data) {
  yield put({ type: GET_PAYMENTS_COUNT_LOADING, payload: true });
  try {
    let res = yield call(Api.getPaymentsCount, data.payload);
    if (res.message) {
      yield put({ type: GET_PAYMENTS_COUNT_ERROR, payload: res.message })
    } else yield put({ type: GET_PAYMENTS_COUNT_SUCCESS, payload: (res?.count || 0) })
  } catch (error) {
    yield put({ type: GET_PAYMENTS_COUNT_ERROR, payload: error.message })
  }
}

function* updateCompanyPaymentSaga(data) {
  yield put({ type: UPDATE_COMPANY_PAYMENT_LOADING, payload: true });
  try {
    let res = yield call(Api.updateCompanyPayments, data.payload, data.payment_id);
    if (res.message) {
      yield put({ type: UPDATE_COMPANY_PAYMENT_ERROR, payload: res.message })
    } else {
      yield put({ type: UPDATE_COMPANY_PAYMENT_SUCCESS, payload: res })
      // yield put({ type: GET_COMPANY_PAYMENT_ACTION, payload: {"page_size": 10}}) // refresh company payment
    }
  } catch (error) {
    yield put({ type: UPDATE_COMPANY_PAYMENT_ERROR, payload: error.message })
  }
}

function* getWithdrawalLimitCategoriesSaga(action) {
  yield put({ type: GET_WITHDRAWAL_CATEGORIES_LOADING });
  try {
    let res = yield call(Api.getWithdrawalLimitCategories, action.payload);
    if (res.message) {
      yield put({ type: GET_WITHDRAWAL_CATEGORIES_ERROR, payload: res.message })
    } else yield put({ type: GET_WITHDRAWAL_CATEGORIES_SUCCESS, payload: res })
  } catch (error) {
    yield put({ type: GET_WITHDRAWAL_CATEGORIES_ERROR, payload: error.message })
  }
}

function* createWithdrawalLimitCategorySaga(action) {
  yield put({ type: CREATE_WITHDRAWAL_CATEGORY_LOADING });
  try {
    let res = yield call(Api.createWithdrawalLimitCategory, action.payload);
    if (res.message) {
      yield put({ type: CREATE_WITHDRAWAL_CATEGORY_ERROR, payload: res.message })
    } else yield put({ type: CREATE_WITHDRAWAL_CATEGORY_SUCCESS, payload: res })
  } catch (error) {
    yield put({ type: CREATE_WITHDRAWAL_CATEGORY_ERROR, payload: error.message })
  }
}

function* updateWithdrawalLimitCategorySaga(action) {
  yield put({ type: UPDATE_WITHDRAWAL_CATEGORY_LOADING });
  try {
    let res = yield call(Api.updateWithdrwalLimitCategory, action.category_id, action.payload);
    if (res.message) {
      yield put({ type: UPDATE_WITHDRAWAL_CATEGORY_ERROR, payload: res.message });

    } else yield put({ type: UPDATE_WITHDRAWAL_CATEGORY_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: UPDATE_WITHDRAWAL_CATEGORY_ERROR, payload: error.message });
  }
}

function* deleteWithdrawalLimitCategorySaga(action) {
  yield put({ type: DELETE_WITHDRAWAL_CATEGORY_LOADING });
  try {
    let res = yield call(Api.deleteWithdrawalLimitCategory, action.payload.id);
    if (res.message) {
      yield put({ type: DELETE_WITHDRAWAL_CATEGORY_ERROR, payload: res.message });
    } else yield put({ type: DELETE_WITHDRAWAL_CATEGORY_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: DELETE_WITHDRAWAL_CATEGORY_ERROR, payload: error.message });
  }
}

function* getWithdrawalLimitCategoryInfoSaga(data) {
  yield put({ type: GET_WITHDRAWAL_CATEGORY_LOADING });
  try {
    let res = yield call(Api.getWithdrwalLimitCategory, data.payload);
    if (res.message) {
      yield put({ type: GET_WITHDRAWAL_CATEGORY_ERROR, payload: res.message });
    } else yield put({ type: GET_WITHDRAWAL_CATEGORY_SUCCESS, payload: res.data });
  } catch (error) {
    yield put({ type: GET_WITHDRAWAL_CATEGORY_ERROR, payload: error.message });
  }
}


function* getMerchantListSaga(data) {
  yield put({ type: MERCHANT_LIST_LOADING });
  try {
    let res = yield call(Api.getMerchantList, data.payload);
    if (res.message) {
      yield put({ type: MERCHANT_LIST_ERROR, payload: res.message });
    } else {
      yield put({ type: MERCHANT_LIST_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: MERCHANT_LIST_ERROR, payload: error.message });
  }
}

function* getMerchantInfoSaga(data) {
  yield put({ type: GET_MERCHANT_LOADING });
  try {
    let res = yield call(Api.getMerchantInfo, data.merchant_id);
    if (res.message) {
      yield put({ type: GET_MERCHANT_ERROR, payload: res.message });
    } else {
      yield put({ type: GET_MERCHANT_SUCCESS, payload: res.data });
    }
  } catch (error) {
    yield put({ type: GET_MERCHANT_ERROR, payload: error.message });
  }
}

function* inviteMerchantSaga(data) {
  yield put({ type: INVITE_MERCHANT_LOADING });
  try {
    let res = yield call(Api.inviteMerchant, data.payload);
    if (res.message) {
      yield put({ type: INVITE_MERCHANT_ERROR, payload: res.message });
    } else {
      yield put({ type: INVITE_MERCHANT_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: INVITE_MERCHANT_ERROR, payload: error.message });
  }
}

function* updateMerchantSaga(data) {
  yield put({ type: UPDATE_MERCHANT_LOADING });
  try {
    let res = yield call(Api.updateMerchant, data.merchant_id, data.payload);
    if (res.message) {
      yield put({ type: UPDATE_MERCHANT_ERROR, payload: res.message });
    } else {
      yield put({ type: UPDATE_MERCHANT_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: UPDATE_MERCHANT_ERROR, payload: error.message });
  }
}

function* reactivateVendorSaga(data) {
  yield put({ type: REACTIVATE_VENDOR_LOADING });
  try {
    let res = yield call(Api.reactivateVendor, data.vendor_id);
    if (res.message) {
      yield put({ type: REACTIVATE_VENDOR_ERROR, payload: res.message });
    } else {
      yield put({ type: REACTIVATE_VENDOR_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: REACTIVATE_VENDOR_ERROR, payload: error.message });
  }
}

function* suspendVendorSaga(data) {
  yield put({ type: SUSPEND_VENDOR_LOADING });
  try {
    let res = yield call(Api.suspendVendor, data.vendor_id);
    if (res.message) {
      yield put({ type: SUSPEND_VENDOR_ERROR, payload: res.message });
    } else {
      yield put({ type: SUSPEND_VENDOR_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: SUSPEND_VENDOR_ERROR, payload: error.message });
  }
}
function* promoteHrTOAdminSaga(data) {
  yield put({ type: PROMOTE_HR_TO_ADMIN_LOADING })
  try {
    let res = yield call(Api.hrToAdmin, data.payload);
    if (res.message) {
      yield put({ type: PROMOTE_HR_TO_ADMIN_ERROR, payload: res.message });
    } else yield put({ type: PROMOTE_HR_TO_ADMIN_SUCCESS, payload: res.data });
  } catch (e) {
    yield put({ type: PROMOTE_HR_TO_ADMIN_ERROR, payload: e.message });
  }
}

function* getUserActivityLogsSaga(data) {
  yield put({ type: GET_USER_ACTIVITY_LOGS_LOADING });
  try {
    let res = yield call(Api.getUserActivityLogs, data.payload);
    if (res.message) {
      yield put({ type: GET_USER_ACTIVITY_LOGS_ERROR, payload: res.message });
    } else yield put({ type: GET_USER_ACTIVITY_LOGS_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: GET_USER_ACTIVITY_LOGS_ERROR, payload: error.message });
  }

}

function* getVendorPaymentsSaga(data) {
  yield put({ type: GET_VENDOR_PAYMENTS_LOADING });
  try {
    let res = yield call(Api.getVendorPayments, data.vendor_id, data.payload);
    if (res.message) {
      yield put({ type: GET_VENDOR_PAYMENTS_ERROR, payload: res.message });
    } else {
      yield put({ type: GET_VENDOR_PAYMENTS_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_PAYMENTS_ERROR, payload: error.message });
  }
}

function* getVendorFeesSaga(data) {
  yield put({ type: GET_VENDOR_FEES_LOADING });
  try {
    let res = yield call(Api.getVendorFees, data.payload);
    if (res.message) {
      yield put({ type: GET_VENDOR_FEES_ERROR, payload: res.message });
    } else {
      yield put({ type: GET_VENDOR_FEES_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_FEES_ERROR, payload: error.message });
  }
}

function* createVendorFeesSaga(data) {
  yield put({ type: CREATE_VENDOR_FEES_LOADING });
  try {
    let res = yield call(Api.createVendorFees, data.payload);
    if (res.message) {
      yield put({ type: CREATE_VENDOR_FEES_ERROR, payload: res.message });
    } else {
      yield put({ type: CREATE_VENDOR_FEES_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: CREATE_VENDOR_FEES_ERROR, payload: error.message });
  }
}

function* updateVendorFeesSaga(data) {
  yield put({ type: UPDATE_VENDOR_FEES_LOADING });
  try {
    let res = yield call(Api.updateVendorFees, data.payload);
    if (res.message) {
      yield put({ type: UPDATE_VENDOR_FEES_ERROR, payload: res.message });
    } else {
      yield put({ type: UPDATE_VENDOR_FEES_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: UPDATE_VENDOR_FEES_ERROR, payload: error.message });
  }
}

function* deleteVendorFeesSaga(data) {
  yield put({ type: DELETE_VENDOR_FEES_LOADING });
  try {
    let res = yield call(Api.deleteVendorFees, data.fee_range_id);
    if (res.message) {
      yield put({ type: DELETE_VENDOR_FEES_ERROR, payload: res.message });
    } else {
      yield put({ type: DELETE_VENDOR_FEES_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: DELETE_VENDOR_FEES_ERROR, payload: error.message });
  }
}

function* getCompanyFeesSaga(data) {
  yield put({ type: GET_COMPANY_FEES_LOADING });
  try {
    let res = yield call(Api.getCompanyFees, data.payload);
    if (res.message) {
      yield put({ type: GET_COMPANY_FEES_ERROR, payload: res.message });
    } else {
      yield put({ type: GET_COMPANY_FEES_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: GET_COMPANY_FEES_ERROR, payload: error.message });
  }
}

function* createCompanyFeesSaga(data) {
  yield put({ type: CREATE_COMPANY_FEES_LOADING });
  try {
    let res = yield call(Api.createCompanyFees, data.payload);
    if (res.message) {
      yield put({ type: CREATE_COMPANY_FEES_ERROR, payload: res.message });
    } else {
      yield put({ type: CREATE_COMPANY_FEES_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: CREATE_COMPANY_FEES_ERROR, payload: error.message });
  }
}

function* updateCompanyFeesSaga(data) {
  yield put({ type: UPDATE_COMPANY_FEES_LOADING });
  try {
    let res = yield call(Api.updateCompanyFees, data.payload);
    if (res.message) {
      yield put({ type: UPDATE_COMPANY_FEES_ERROR, payload: res.message });
    } else {
      yield put({ type: UPDATE_COMPANY_FEES_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: UPDATE_COMPANY_FEES_ERROR, payload: error.message });
  }
}

function* deleteCompanyFeesSaga(data) {
  yield put({ type: DELETE_COMPANY_FEES_LOADING });
  try {
    let res = yield call(Api.deleteCompanyFees, data.fee_range_id);
    if (res.message) {
      yield put({ type: DELETE_COMPANY_FEES_ERROR, payload: res.message });
    } else {
      yield put({ type: DELETE_COMPANY_FEES_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: DELETE_COMPANY_FEES_ERROR, payload: error.message });
  }
}

function* getVendorSettlementsSaga(data) {
  yield put({ type: GET_VENDOR_SETTLEMENTS_LOADING });
  try {
    let res = yield call(Api.getVendorSettlements, data.payload);
    if (res.message) {
      yield put({ type: GET_VENDOR_SETTLEMENTS_ERROR, payload: res.message });
    } else {
      yield put({ type: GET_VENDOR_SETTLEMENTS_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_SETTLEMENTS_ERROR, payload: error.message });
  }
}

function* addVendorBankDetailsSaga(data) {
  yield put({ type: ADD_VENDOR_BANK_DETAILS_LOADING });
  try {
    let res = yield call(Api.addVendorBankDetails, data.payload);
    if (res.message) {
      yield put({ type: ADD_VENDOR_BANK_DETAILS_ERROR, payload: res.message });
    } else yield put({ type: ADD_VENDOR_BANK_DETAILS_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: ADD_VENDOR_BANK_DETAILS_ERROR, payload: error.message });
  }
}

function* updateVendorBankDetailsSaga(data) {
  yield put({ type: UPDATE_VENDOR_BANK_DETAILS_LOADING });
  try {
    let res = yield call(Api.updateVendorBankDetails, data.payload);
    if (res.message) {
      yield put({ type: UPDATE_VENDOR_BANK_DETAILS_ERROR, payload: res.message });
    } else yield put({ type: UPDATE_VENDOR_BANK_DETAILS_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: UPDATE_VENDOR_BANK_DETAILS_ERROR, payload: error.message });
  }
}

function* deleteVendorBankDetailsSaga(data) {
  yield put({ type: DELETE_VENDOR_BANK_DETAILS_LOADING });
  try {
    let res = yield call(Api.deleteVendorBankDetails, data.payload);
    if (res.message) {
      yield put({ type: DELETE_VENDOR_BANK_DETAILS_ERROR, payload: res.message });
    } else yield put({ type: DELETE_VENDOR_BANK_DETAILS_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: DELETE_VENDOR_BANK_DETAILS_ERROR, payload: error.message });
  }
}

function* getVendorBankDetailsSaga(data) {
  yield put({ type: GET_VENDOR_BANK_DETAILS_LOADING });
  try {
    let res = yield call(Api.getVendorBankDetails, data.payload);
    if (res.message) {
      yield put({ type: GET_VENDOR_BANK_DETAILS_ERROR, payload: res.message });
    } else yield put({ type: GET_VENDOR_BANK_DETAILS_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: GET_VENDOR_BANK_DETAILS_ERROR, payload: error.message });
  }
}

function* listVendorBankDetailsSaga(data) {
  yield put({ type: LIST_VENDOR_BANK_DETAILS_LOADING });
  try {
    let res = yield call(Api.listVendorBankDetails, data.payload);
    if (res.message) {
      yield put({ type: LIST_VENDOR_BANK_DETAILS_ERROR, payload: res.message });
    } else yield put({ type: LIST_VENDOR_BANK_DETAILS_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: LIST_VENDOR_BANK_DETAILS_ERROR, payload: error.message });
  }
}

function* getPaystackBanksListSaga(data) {
  yield put({ type: GET_PAYSTACK_BANKS_LIST_LOADING });
  try {
    let res = yield call(Api.getPaystackBanksList, data.payload);
    if (res.message) {
      yield put({ type: GET_PAYSTACK_BANKS_LIST_ERROR, payload: res.message });
    } else yield put({ type: GET_PAYSTACK_BANKS_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: GET_PAYSTACK_BANKS_LIST_ERROR, payload: error.message });
  }
}

function* verifyPaystackBankAccountSaga(data) {
  yield put({ type: VERIFY_PAYSTACK_BANK_ACCOUNT_LOADING });
  try {
    let res = yield call(Api.verifyPaystackBankAccount, data.payload);
    if (res.message) {
      yield put({ type: VERIFY_PAYSTACK_BANK_ACCOUNT_ERROR, payload: res?.data?.message || res.message || "Failed to verify bank account" });
    } else yield put({ type: VERIFY_PAYSTACK_BANK_ACCOUNT_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: VERIFY_PAYSTACK_BANK_ACCOUNT_ERROR, payload: error?.message || "Failed to verify bank account" });
  }
}

// Single-object campaign endpoints (detail, stats, create, update, action) wrap
// their payload in `{ data: { ... } }`. Paginated endpoints (list, history)
// keep `{ count, next, previous, data: [...] }` at the top level. Unwrap the
// envelope only when storing a single object — checked by the absence of
// pagination keys so a payload that already lacks the wrapper passes through.
const unwrapCampaignObject = (res) => {
  if (!res || typeof res !== "object") return res;
  if ("count" in res || "next" in res || "previous" in res) return res;
  if (res.data && typeof res.data === "object" && !Array.isArray(res.data)) return res.data;
  return res;
};

const workflowActionApiMap = {
  "submit-review": "submitReview",
  approve: "approveCampaign",
  activate: "activateCampaign",
  deactivate: "deactivateCampaign",
  end: "endCampaign",
};

export function* getCampaignConfigSaga(action) {
  yield put({ type: CAMPAIGN_CONFIG_REQUEST_LOADING });
  try {
    const res = yield call(Api.fetchCampaignConfig);
    if (res.message) {
      yield put({ type: CAMPAIGN_CONFIG_REQUEST_ERROR, payload: res.message });
      if (action?.onFailure) action.onFailure(res);
      return;
    }
    const normalizedConfig = normalizeCampaignConfig(res);
    yield put({ type: CAMPAIGN_CONFIG_REQUEST_SUCCESS, payload: normalizedConfig });
    if (action?.onSuccess) action.onSuccess(normalizedConfig);
  } catch (error) {
    yield put({ type: CAMPAIGN_CONFIG_REQUEST_ERROR, payload: error.message });
    if (action?.onFailure) action.onFailure(error);
  }
}

function* getCampaignListSaga(action) {
  yield put({ type: CAMPAIGN_LIST_REQUEST_LOADING });
  try {
    const res = yield call(Api.fetchCampaigns, action.payload);
    if (res.message) {
      yield put({ type: CAMPAIGN_LIST_REQUEST_ERROR, payload: res.message });
      if (action?.onFailure) action.onFailure(res);
      return;
    }
    yield put({ type: CAMPAIGN_LIST_REQUEST_SUCCESS, payload: res });
    if (action?.onSuccess) action.onSuccess(res);
  } catch (error) {
    yield put({ type: CAMPAIGN_LIST_REQUEST_ERROR, payload: error.message });
    if (action?.onFailure) action.onFailure(error);
  }
}

function* getCampaignDetailSaga(action) {
  yield put({ type: CAMPAIGN_DETAIL_REQUEST_LOADING });
  try {
    const res = yield call(Api.fetchCampaign, action.campaignId);
    if (res.message) {
      yield put({ type: CAMPAIGN_DETAIL_REQUEST_ERROR, payload: res.message });
      if (action?.onFailure) action.onFailure(res);
      return;
    }
    const detail = unwrapCampaignObject(res);
    yield put({ type: CAMPAIGN_DETAIL_REQUEST_SUCCESS, payload: detail });
    if (action?.onSuccess) action.onSuccess(detail);
  } catch (error) {
    yield put({ type: CAMPAIGN_DETAIL_REQUEST_ERROR, payload: error.message });
    if (action?.onFailure) action.onFailure(error);
  }
}

function* refreshCampaignDependentData(campaignId) {
  const campaign = yield select((state) => state.dashboardReducer?.campaigns);
  const listPayload = { ...(campaign?.filters || {}), ...(campaign?.pagination || {}) };
  const historyPayload = { ...(campaign?.historyPagination || {}) };
  yield put({ type: CAMPAIGN_DETAIL_REQUEST_ACTION, campaignId });
  yield put({ type: CAMPAIGN_LIST_REQUEST_ACTION, payload: listPayload });
  yield put({ type: CAMPAIGN_STATS_REQUEST_ACTION, campaignId });
  yield put({ type: CAMPAIGN_HISTORY_REQUEST_ACTION, campaignId, payload: historyPayload });
}

function* createCampaignSaga(action) {
  yield put({ type: CAMPAIGN_CREATE_REQUEST_LOADING });
  try {
    const prepared = buildCampaignPayload(action.payload || {});
    if (prepared?.hasInvalidRows) {
      const message = "Please complete or remove invalid eligibility rule rows.";
      yield put({ type: CAMPAIGN_CREATE_REQUEST_ERROR, payload: message });
      if (action?.onFailure) action.onFailure({ message, details: prepared.ruleErrors });
      return;
    }

    const res = yield call(Api.createCampaign, prepared.payload);
    if (res.message) {
      yield put({ type: CAMPAIGN_CREATE_REQUEST_ERROR, payload: res.details || res.message });
      if (action?.onFailure) action.onFailure(res);
      return;
    }
    const created = unwrapCampaignObject(res);
    yield put({ type: CAMPAIGN_CREATE_REQUEST_SUCCESS, payload: created });
    const campaignId = created?.id;
    if (campaignId) {
      yield call(refreshCampaignDependentData, campaignId);
    } else {
      const campaign = yield select((state) => state.dashboardReducer?.campaigns);
      const listPayload = { ...(campaign?.filters || {}), ...(campaign?.pagination || {}) };
      yield put({ type: CAMPAIGN_LIST_REQUEST_ACTION, payload: listPayload });
    }
    if (action?.onSuccess) action.onSuccess(created);
  } catch (error) {
    yield put({ type: CAMPAIGN_CREATE_REQUEST_ERROR, payload: error.message });
    if (action?.onFailure) action.onFailure(error);
  }
}

function* updateCampaignSaga(action) {
  yield put({ type: CAMPAIGN_UPDATE_REQUEST_LOADING });
  try {
    const prepared = buildCampaignPayload(action.payload || {});
    if (prepared?.hasInvalidRows) {
      const message = "Please complete or remove invalid eligibility rule rows.";
      yield put({ type: CAMPAIGN_UPDATE_REQUEST_ERROR, payload: message });
      if (action?.onFailure) action.onFailure({ message, details: prepared.ruleErrors });
      return;
    }

    const res = yield call(Api.updateCampaign, action.campaignId, prepared.payload);
    if (res.message) {
      yield put({ type: CAMPAIGN_UPDATE_REQUEST_ERROR, payload: res.details || res.message });
      if (action?.onFailure) action.onFailure(res);
      return;
    }
    const updated = unwrapCampaignObject(res);
    yield put({ type: CAMPAIGN_UPDATE_REQUEST_SUCCESS, payload: updated });
    yield call(refreshCampaignDependentData, action.campaignId);
    if (action?.onSuccess) action.onSuccess(updated);
  } catch (error) {
    yield put({ type: CAMPAIGN_UPDATE_REQUEST_ERROR, payload: error.message });
    if (action?.onFailure) action.onFailure(error);
  }
}

function* campaignActionSaga(action) {
  yield put({ type: CAMPAIGN_ACTION_REQUEST_LOADING });
  try {
    const method = workflowActionApiMap[action.workflowAction];
    if (!method) throw new Error("Unsupported campaign workflow action");
    const res = yield call(Api[method], action.campaignId, action.payload || {});
    if (res.message) {
      yield put({ type: CAMPAIGN_ACTION_REQUEST_ERROR, payload: res.details || res.message });
      if (action?.onFailure) action.onFailure(res);
      return;
    }
    const actionRes = unwrapCampaignObject(res);
    yield put({ type: CAMPAIGN_ACTION_REQUEST_SUCCESS, payload: actionRes });
    yield call(refreshCampaignDependentData, action.campaignId);
    if (action?.onSuccess) action.onSuccess(actionRes);
  } catch (error) {
    yield put({ type: CAMPAIGN_ACTION_REQUEST_ERROR, payload: error.message });
    if (action?.onFailure) action.onFailure(error);
  }
}

function* getCampaignStatsSaga(action) {
  yield put({ type: CAMPAIGN_STATS_REQUEST_LOADING });
  try {
    const res = yield call(Api.fetchCampaignStats, action.campaignId);
    if (res.message) {
      yield put({ type: CAMPAIGN_STATS_REQUEST_ERROR, payload: res.message });
      if (action?.onFailure) action.onFailure(res);
      return;
    }
    const stats = unwrapCampaignObject(res);
    yield put({ type: CAMPAIGN_STATS_REQUEST_SUCCESS, payload: stats });
    if (action?.onSuccess) action.onSuccess(stats);
  } catch (error) {
    yield put({ type: CAMPAIGN_STATS_REQUEST_ERROR, payload: error.message });
    if (action?.onFailure) action.onFailure(error);
  }
}

function* getCampaignHistorySaga(action) {
  yield put({ type: CAMPAIGN_HISTORY_REQUEST_LOADING });
  try {
    const res = yield call(Api.fetchCampaignHistory, action.campaignId, action.payload || {});
    if (res.message) {
      yield put({ type: CAMPAIGN_HISTORY_REQUEST_ERROR, payload: res.message });
      if (action?.onFailure) action.onFailure(res);
      return;
    }
    yield put({ type: CAMPAIGN_HISTORY_REQUEST_SUCCESS, payload: res });
    if (action?.onSuccess) action.onSuccess(res);
  } catch (error) {
    yield put({ type: CAMPAIGN_HISTORY_REQUEST_ERROR, payload: error.message });
    if (action?.onFailure) action.onFailure(error);
  }
}

function* setCampaignFiltersSaga(action) {
  yield put({ type: CAMPAIGN_SET_FILTERS_SUCCESS, payload: action.payload });
}

function* setCampaignPaginationSaga(action) {
  yield put({ type: CAMPAIGN_SET_PAGINATION_SUCCESS, payload: action.payload });
}

function* setCampaignHistoryPaginationSaga(action) {
  yield put({ type: CAMPAIGN_SET_HISTORY_PAGINATION_SUCCESS, payload: action.payload });
}

function* resetCampaignFormErrorsSaga() {
  yield put({ type: CAMPAIGN_RESET_FORM_ERRORS_SUCCESS });
}

function* clearCampaignToastSaga() {
  yield put({ type: CAMPAIGN_CLEAR_TOAST_SUCCESS });
}

function* vendorSettlementTriggerSaga(data) {
  yield put({ type: VENDOR_SETTLEMENT_TRIGGER_LOADING });
  try {

    let res = yield call(Api.vendorOutstandingSettlementTrigger, data.payload);
    if (res.message) {
      yield put({ type: VENDOR_SETTLEMENT_TRIGGER_ERROR, payload: res?.message });
    } else yield put({ type: VENDOR_SETTLEMENT_TRIGGER_SUCCESS, payload: res });

  } catch (error) {
    yield put({ type: VENDOR_SETTLEMENT_TRIGGER_ERROR, payload: error?.message });
  }
}

function* vendorResendInvitationSaga(data) {
  yield put({ type: VENDOR_RESEND_INVITATION_LOADING });
  try {

    let res = yield call(Api.venodrResendInvitation, data.payload);
    if (res.message) {
      yield put({ type: VENDOR_RESEND_INVITATION_ERROR, payload: res?.message });
    } else yield put({ type: VENDOR_RESEND_INVITATION_SUCCESS, payload: res });

  } catch (error) {
    yield put({ type: VENDOR_RESEND_INVITATION_ERROR, payload: error?.message });
  }
}

function* vendorSettlementTriggerAggregateSaga(data) {
  yield put({ type: VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_LOADING });
  try {

    let res = yield call(Api.vendorOutstandingSettlementTriggerAggregate, data.payload);
    if (res.message) {
      yield put({ type: VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ERROR, payload: res?.message });
    } else yield put({ type: VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_SUCCESS, payload: res });

  } catch (error) {
    yield put({ type: VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ERROR, payload: error?.message });
  }
}

function* onBoardCompanyEmployeesSaga(data) {
  yield put({ type: ONBOARD_COMPANY_EMPLOYEES_LOADING });
  try {
    let res = yield call(Api.onBoardCompanyEmployees, data.payload);
    if (res.message) {
      yield put({ type: ONBOARD_COMPANY_EMPLOYEES_ERROR, payload: res.message });
    } else yield put({ type: ONBOARD_COMPANY_EMPLOYEES_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: ONBOARD_COMPANY_EMPLOYEES_ERROR, payload: error.message });
  }
}

/* ── Payment-gateway config (Fortress) ──────────────────────────────────── */

function* getFortressCompaniesSaga() {
  yield put({ type: GET_FORTRESS_COMPANIES_LOADING });
  try {
    let res = yield call(Api.getFortressCompanies);
    if (res && res.message) {
      yield put({ type: GET_FORTRESS_COMPANIES_ERROR, payload: res.message });
    } else {
      yield put({
        type: GET_FORTRESS_COMPANIES_SUCCESS,
        payload: Array.isArray(res) ? res : res?.data || res?.results || [],
      });
    }
  } catch (error) {
    yield put({ type: GET_FORTRESS_COMPANIES_ERROR, payload: error.message });
  }
}

function* updateFortressCompaniesSaga(data) {
  yield put({ type: UPDATE_FORTRESS_COMPANIES_LOADING });
  try {
    let res = yield call(Api.updateFortressCompanies, data.payload);
    if (res && res.message) {
      yield put({ type: UPDATE_FORTRESS_COMPANIES_ERROR, payload: res.message });
    } else {
      // Response is the updated list — reconcile the current set from it.
      yield put({
        type: UPDATE_FORTRESS_COMPANIES_SUCCESS,
        payload: Array.isArray(res) ? res : res?.data || res?.results || [],
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_FORTRESS_COMPANIES_ERROR, payload: error.message });
  }
}

function* getFortressBankCodesSaga(data) {
  yield put({ type: FORTRESS_BANK_CODE_LIST_LOADING });
  try {
    let res = yield call(Api.getFortressBankCodes, data.payload);
    if (res && res.message) {
      yield put({ type: FORTRESS_BANK_CODE_LIST_ERROR, payload: res.message });
    } else {
      yield put({ type: FORTRESS_BANK_CODE_LIST_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: FORTRESS_BANK_CODE_LIST_ERROR, payload: error.message });
  }
}

function* updateFortressBankCodeSaga(data) {
  yield put({ type: UPDATE_FORTRESS_BANK_CODE_LOADING });
  try {
    let res = yield call(Api.updateFortressBankCode, data.payload, data.id);
    if (res && res.message) {
      yield put({
        type: UPDATE_FORTRESS_BANK_CODE_ERROR,
        payload: res.message,
        fieldErrors: res.details || null,
      });
    } else {
      yield put({
        type: UPDATE_FORTRESS_BANK_CODE_SUCCESS,
        payload: res && res.data ? res.data : res,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_FORTRESS_BANK_CODE_ERROR, payload: error.message });
  }
}

function* watchDashboardAsync() {
  yield takeLatest(PAYMENT_LIST_ACTION, getPaymentListSaga);
  yield takeLatest(PAYMENT_DOWNLOAD_ACTION, getPaymentDownloadSaga);
  yield takeLatest(PAYMENT_DOWNLOAD_RESET_ACTION, resetPaymentDownloadSaga);
  yield takeLatest(GET_PAYMENT_ACTION, getPaymentInfoSaga);
  yield takeLatest(SETTLE_PAYMENT_ACTION, settlePaymentSaga);
  yield takeLatest(MONTHS_TO_SETTLE_ACTION, getMonthsToSettleSaga);
  yield takeLatest(BULK_MONTHS_TO_SETTLE_ACTION, getBulkMonthsToSettleSaga);
  yield takeLatest(SETTLE_SALARY_ACTION, settleSalarySaga);
  yield takeLatest(BULK_SETTLE_SALARY_ACTION, bulkSettleSalarySaga);
  yield takeLatest(COMPANY_LIST_ACTION, getCompanyListSaga);
  yield takeLatest(GET_COMPANY_ACTION, getCompanyInfoSaga);
  yield takeLatest(EMPLOYEE_LIST_ACTION, getEmployeeListSaga);
  yield takeLatest(GET_EMPLOYEE_ACTION, getEmployeeInfoSaga);
  yield takeLatest(OVERVIEW_ACTION, getOverviewSaga);
  yield takeLatest(INVITE_COMPANY_ACTION, inviteCompanySaga);
  yield takeLatest(UPDATE_COMPANY_ACTION, updateCompanySaga);
  yield takeLatest(EXCHANGE_LIST_ACTION, getExchangeListSaga);
  yield takeLatest(GET_EXCHANGE_ACTION, getExchangeInfoSaga);
  yield takeLatest(CREATE_EXCHANGE_ACTION, createExchangeSaga);
  yield takeLatest(UPDATE_EXCHANGE_ACTION, updateExchangeSaga);
  yield takeLatest(DELETE_EXCHANGE_ACTION, deleteExchangeSaga);
  yield takeLatest(BACKOFFICE_DEDUCTION_LIST_ACTION, getDeductionListSaga);
  yield takeLatest(GET_DEDUCTION_ACTION, getDeductionInfoSaga);
  yield takeLatest(CREATE_DEDUCTION_ACTION, createDeductionSaga);
  yield takeLatest(UPDATE_DEDUCTION_ACTION, updateDeductionSaga);
  yield takeLatest(DELETE_DEDUCTION_ACTION, deleteDeductionSaga);
  yield takeLatest(BONUS_LIST_ACTION, getBonusListSaga);
  yield takeLatest(GET_BONUS_ACTION, getBonusInfoSaga);
  yield takeLatest(CREATE_BONUS_ACTION, createBonusSaga);
  yield takeLatest(UPDATE_BONUS_ACTION, updateBonusSaga);
  yield takeLatest(DELETE_BONUS_ACTION, deleteBonusSaga);
  yield takeLatest(BONUS_CLAIM_LIST_ACTION, getBonusClaimListSaga);
  yield takeLatest(GET_BONUS_CLAIM_ACTION, getBonusClaimInfoSaga);
  yield takeLatest(DELETE_BONUS_CLAIM_ACTION, deleteBonusClaimSaga);
  yield takeLatest(PERMISSION_CATALOGUE_ACTION, getPermissionCatalogueSaga);
  yield takeLatest(GROUP_LIST_ACTION, getGroupListSaga);
  yield takeLatest(GET_GROUP_ACTION, getGroupSaga);
  yield takeLatest(CREATE_GROUP_ACTION, createGroupSaga);
  yield takeLatest(UPDATE_GROUP_ACTION, updateGroupSaga);
  yield takeLatest(DELETE_GROUP_ACTION, deleteGroupSaga);
  yield takeLatest(GROUP_MEMBER_LIST_ACTION, getGroupMembersSaga);
  yield takeLatest(ADD_GROUP_MEMBERS_ACTION, addGroupMembersSaga);
  yield takeLatest(REMOVE_GROUP_MEMBERS_ACTION, removeGroupMembersSaga);
  yield takeLatest(NOTIFICATION_COUNT_ACTION, getNotificationCountSaga);
  yield takeLatest(NOTIFICATION_LIST_ACTION, getNotificationsSaga);
  yield takeEvery(MARK_NOTIFICATION_READ_ACTION, markNotificationReadSaga);
  yield takeLatest(MARK_ALL_NOTIFICATIONS_READ_ACTION, markAllNotificationsReadSaga);
  yield takeLatest(GET_FORTRESS_COMPANIES_ACTION, getFortressCompaniesSaga);
  yield takeLatest(UPDATE_FORTRESS_COMPANIES_ACTION, updateFortressCompaniesSaga);
  yield takeLatest(FORTRESS_BANK_CODE_LIST_ACTION, getFortressBankCodesSaga);
  yield takeLatest(UPDATE_FORTRESS_BANK_CODE_ACTION, updateFortressBankCodeSaga);
  yield takeLatest(DOWNLOAD_EMPLOYEE_STATEMENT_ACTION, downloadEmployeeStatementSaga);
  yield takeLatest(OVERVIEW_FILTER_ACTION, setOverviewFilters);
  yield takeLatest(
    TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_ACTION,
    setWithdrawalRequestsFilters
  );
  yield takeLatest(
    TRANSACTIONS_OVERTIME_REQUESTS_FILTER_ACTION,
    setOvertimeRequestsFilters
  );
  yield takeLatest(TRANSACTION_HISTORY_ACTION, transactionHistorySaga);
  yield takeLatest(BACKOFFICE_COUNTRY_FEES_LIST_ACTION, getCountryListSaga);
  yield takeLatest(CREATE_COUNTRY_FEES_ACTION, createCountryFeesSaga);
  yield takeLatest(UPDATE_COUNTRY_FEES_ACTION, updateCountryFeesSaga);
  yield takeLatest(PAYMENT_SUB_TABLE_LIST_ACTION, getPaymentWDSaga);
  yield takeLatest(DECLINE_PAYMENT_ACTION, declineWithdrawalPaymentSaga);
  yield takeLatest(GET_REPORTS_ACTION, getReportAnalysisSaga);
  yield takeLatest(PUSH_NOTIFICATION_ACTION, pushNotificationSaga);
  yield takeLatest(SEND_MONTHLY_COMPANY_REPORTS_ACTION, sendMonthlyCompanyReportsSaga);
  yield takeLatest(SEND_CUSTOM_COMPANY_REPORTS_ACTION, sendCustomCompanyReportsSaga);
  yield takeLatest(GET_PAYMENTS_COUNT_ACTION, getPaymentCountSaga);
  yield takeLatest(UPDATE_COMPANY_PAYMENT_ACTION, updateCompanyPaymentSaga);
  yield takeLatest(GET_WITHDRAWAL_CATEGORIES_ACTION, getWithdrawalLimitCategoriesSaga);
  yield takeLatest(DELETE_WITHDRAWAL_CATEGORY_ACTION, deleteWithdrawalLimitCategorySaga);
  yield takeLatest(UPDATE_WITHDRAWAL_CATEGORY_ACTION, updateWithdrawalLimitCategorySaga);
  yield takeLatest(CREATE_WITHDRAWAL_CATEGORY_ACTION, createWithdrawalLimitCategorySaga);
  yield takeLatest(GET_WITHDRAWAL_CATEGORY_ACTION, getWithdrawalLimitCategoryInfoSaga);
  yield takeLatest(MERCHANT_LIST_ACTION, getMerchantListSaga);
  yield takeLatest(GET_MERCHANT_ACTION, getMerchantInfoSaga);
  yield takeLatest(INVITE_MERCHANT_ACTION, inviteMerchantSaga);
  yield takeLatest(UPDATE_MERCHANT_ACTION, updateMerchantSaga);
  yield takeLatest(REACTIVATE_VENDOR_ACTION, reactivateVendorSaga);
  yield takeLatest(SUSPEND_VENDOR_ACTION, suspendVendorSaga);
  yield takeLatest(PROMOTE_HR_TO_ADMIN_ACTION, promoteHrTOAdminSaga);
  yield takeLatest(GET_USER_ACTIVITY_LOGS_ACTION, getUserActivityLogsSaga);
  yield takeLatest(GET_VENDOR_PAYMENTS_ACTION, getVendorPaymentsSaga);
  yield takeLatest(GET_VENDOR_FEES_ACTION, getVendorFeesSaga);
  yield takeLatest(CREATE_VENDOR_FEES_ACTION, createVendorFeesSaga);
  yield takeLatest(UPDATE_VENDOR_FEES_ACTION, updateVendorFeesSaga);
  yield takeLatest(DELETE_VENDOR_FEES_ACTION, deleteVendorFeesSaga);
  yield takeLatest(GET_COMPANY_FEES_ACTION, getCompanyFeesSaga);
  yield takeLatest(CREATE_COMPANY_FEES_ACTION, createCompanyFeesSaga);
  yield takeLatest(UPDATE_COMPANY_FEES_ACTION, updateCompanyFeesSaga);
  yield takeLatest(DELETE_COMPANY_FEES_ACTION, deleteCompanyFeesSaga);
  yield takeLatest(GET_VENDOR_SETTLEMENTS_ACTION, getVendorSettlementsSaga);
  yield takeLatest(ADD_VENDOR_BANK_DETAILS_ACTION, addVendorBankDetailsSaga);
  yield takeLatest(UPDATE_VENDOR_BANK_DETAILS_ACTION, updateVendorBankDetailsSaga);
  yield takeLatest(DELETE_VENDOR_BANK_DETAILS_ACTION, deleteVendorBankDetailsSaga);
  yield takeLatest(GET_VENDOR_BANK_DETAILS_ACTION, getVendorBankDetailsSaga);
  yield takeLatest(LIST_VENDOR_BANK_DETAILS_ACTION, listVendorBankDetailsSaga);
  yield takeLatest(GET_PAYSTACK_BANKS_LIST_ACTION, getPaystackBanksListSaga);
  yield takeLatest(VERIFY_PAYSTACK_BANK_ACCOUNT_ACTION, verifyPaystackBankAccountSaga);
  yield takeLatest(VENDOR_SETTLEMENT_TRIGGER_ACTION, vendorSettlementTriggerSaga);
  yield takeLatest(VENDOR_RESEND_INVITATION_ACTION, vendorResendInvitationSaga);
  yield takeLatest(VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ACTION, vendorSettlementTriggerAggregateSaga);
  yield takeLatest(ONBOARD_COMPANY_EMPLOYEES_ACTION, onBoardCompanyEmployeesSaga);
  yield takeLatest(CAMPAIGN_CONFIG_REQUEST_ACTION, getCampaignConfigSaga);
  yield takeLatest(CAMPAIGN_LIST_REQUEST_ACTION, getCampaignListSaga);
  yield takeLatest(CAMPAIGN_DETAIL_REQUEST_ACTION, getCampaignDetailSaga);
  yield takeLatest(CAMPAIGN_CREATE_REQUEST_ACTION, createCampaignSaga);
  yield takeLatest(CAMPAIGN_UPDATE_REQUEST_ACTION, updateCampaignSaga);
  yield takeLatest(CAMPAIGN_ACTION_REQUEST_ACTION, campaignActionSaga);
  yield takeLatest(CAMPAIGN_STATS_REQUEST_ACTION, getCampaignStatsSaga);
  yield takeLatest(CAMPAIGN_HISTORY_REQUEST_ACTION, getCampaignHistorySaga);
  yield takeLatest(CAMPAIGN_SET_FILTERS_ACTION, setCampaignFiltersSaga);
  yield takeLatest(CAMPAIGN_SET_PAGINATION_ACTION, setCampaignPaginationSaga);
  yield takeLatest(CAMPAIGN_SET_HISTORY_PAGINATION_ACTION, setCampaignHistoryPaginationSaga);
  yield takeLatest(CAMPAIGN_RESET_FORM_ERRORS_ACTION, resetCampaignFormErrorsSaga);
  yield takeLatest(CAMPAIGN_CLEAR_TOAST_ACTION, clearCampaignToastSaga);
}

export default watchDashboardAsync;
